import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateSubCategory, UpdateSubCategoryParams} from '../api';
import {QUERY__SUB_CATEGORIES} from '../queryKeys';

export const useUpdateSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateSubCategoryParams) => updateSubCategory(params),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__SUB_CATEGORIES, variables.categorySlug],
      });
    },
  });
};
